import { keepPreviousData, useMutation, useQuery, useQueryClient } from '@tanstack/react-query'

import { queryKeys } from '@/constants/queryKeys'
import { CustomerModel } from '@/http/models'
import { PosHttpParams } from '@/types'

import { unwrap } from '../unwrap'

export const useCustomers = (search: string, enabled = true) =>
  useQuery({
    queryKey: queryKeys.customers(search),
    queryFn: () => unwrap(CustomerModel.getList({ search })),
    placeholderData: keepPreviousData,
    enabled,
  })

export const useCreateCustomer = () => {
  const client = useQueryClient()
  return useMutation({
    mutationFn: (body: PosHttpParams.CreateCustomer) => unwrap(CustomerModel.create(body)),
    onSuccess: () => client.invalidateQueries({ queryKey: ['customers'] }),
  })
}

export const useUpdateCustomer = () => {
  const client = useQueryClient()
  return useMutation({
    mutationFn: (input: { id: string; body: PosHttpParams.CreateCustomer }) => unwrap(CustomerModel.update(input.id, input.body)),
    onSuccess: () => client.invalidateQueries({ queryKey: ['customers'] }),
  })
}

export const useRepayCredit = () => {
  const client = useQueryClient()
  return useMutation({
    mutationFn: (input: { customerId: string; amount: number; method: string; remark?: string }) =>
      unwrap(CustomerModel.repayCredit(input.customerId, input.amount, input.method, input.remark)),
    onSuccess: () => {
      client.invalidateQueries({ queryKey: ['customers'] })
      client.invalidateQueries({ queryKey: ['shift'] })
    },
  })
}
